import React from "react";
import { useTranslation } from "react-i18next";

const BOMNotes: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bom-notes">
      <h4>{t("bom.orderingNotes")}</h4>
      <ul className="notes-list">
        <li>{t("bom.note1")}</li>
        <li>{t("bom.note2")}</li>
        <li>{t("bom.note3")}</li>
        <li>{t("bom.note4")}</li>
      </ul>
    </div>
  );
};

export default BOMNotes;
